<div class="rules-card fade-in">

    <!-- Icon -->
    <div class="rules-icon-wrap">
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
        <path d="M9 11l3 3L22 4"></path>
        <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"></path>
      </svg>
    </div>
  
    <h2 class="rules-header">{{ rules.header }}</h2>
    <p class="rules-subheader">{{ rules.subHeader }}</p>
  
    <div class="rules-divider"></div>
  
    <section *ngFor="let section of rules.sections" class="rules-section">
      <h3 class="rules-section-title">{{ section.title }}</h3>
      <ul class="rules-list">
        <li *ngFor="let rule of section.rules; let i = index" class="rule-item" [style.animation-delay]="(i * 80) + 'ms'">
          <span class="rule-bullet" aria-hidden="true"></span>
          <span class="rule-text">{{ rule }}</span>
        </li>
      </ul>
    </section>
  
    <div class="rules-footer">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      <span>For any issues, please reach out to us at <a [href]="'mailto:' + rules.supportEmail">{{ rules.supportEmail }}</a>.</span>
    </div>
  
  </div>
